import React from "react";
import { Typography, useMediaQuery, Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import TechnologiesCarrousel from "../Carrousel/TechnologiesCarrousel";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  titleContainer: {
    marginTop: isMobile ? "110.4px" : "262.3px",
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    backgroundColor: theme.palette.red.main,
  },
  jsLogo: {
    height: "78px",
  },
  nodeLogo: {
    width: "132px",
  },
  typography: {
    descriptionSubtitle: {
      fontSize: isMobile ? 14 : 16,
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      margin: "8rem 0 10px",
    },
    descriptionTitle: {
      fontSize: isMobile ? 32 : 65,
      fontWeight: "lighter",
      fontFamily: theme.typography.montserrat.regular,
      color: theme.palette.blue.main,
      lineHeight: "43px",
      marginTop: isMobile ? "0" : "52px",
    },
    section: {
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      marginTop: isMobile ? "59px" : "0",
    },
  },
});

const Technologies = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "Technologies");

  return isMobile ? (
    <>
      <Typography sx={classes.typography.descriptionSubtitle}>
        {title}
      </Typography>
      <Typography sx={classes.typography.descriptionTitle}>
        <b>
          {subtitle[0]}
          <br />
          {subtitle[1]}
        </b>
      </Typography>
      <TechnologiesCarrousel />
    </>
  ) : (
    <>
      <Box sx={classes.titleContainer}>
        <div style={classes.line}></div>
        <Typography sx={classes.typography.section}>{title}</Typography>
      </Box>
      <Typography sx={classes.typography.descriptionTitle}>
        <b>{subtitle}</b>
      </Typography>
      <TechnologiesCarrousel />
    </>
  );
};

export default Technologies;
